import CsvExportor from "csv-exportor";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import XLSXStyle from 'xlsx-style';
import axios, { axiosDelete, get, post, put } from '../../utils/http';
import { setCookie } from "../../utils/package-cookies";
import { getItemFormLocalstorage, setItemToLocalstorage } from "../../utils/package-localstorage";
import storeIndex from '../store/index';

//带cookie
//axios.defaults.withCredentials = true;
axios.defaults.headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': true,
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
  'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
}
//Building
export function GetBuildingAlls(FilterText = "", Sorting = 'id ASC', MaxResultCount = 6, SkipCount = 0) {
  return get(`/api/services/app/Building/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`);
}
//City
export function getCityAll(FilterText = "", Sorting = 'id ASC', MaxResultCount = 6, SkipCount = 0) {
  return get(`/api/services/app/City/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`);
}


export function addCity(data) {
  return post(`/api/services/app/City/Create`, data);
}

export function editCity(data) {
  return put(`/api/services/app/City/Update`, data);
}

export function deleteCity(data) {
  return axiosDelete(`/api/services/app/City/Delete`, data)
}

export function GetCityList() {
  return get(`/api/services/app/City/GetCityList`)
}

//Agency 经销商列表
export function getAgencys() {
  let brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/Agency/GetAgencys?brandCode=${brandCode}`)
}
//Agency 经销商列表
export function getAgencyList(data) {
  data.Brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/Agency/GetAgencysPage`, data)
}
export function getAgencyById(id) {
  return get(`/api/services/app/Agency/GetAgencysById`, id)
}

export function addAgency(data) {
  return post('/api/services/app/Agency/AddAgency', data)
}

export function updateAgency(data) {
  return put('/api/services/app/Agency/UpdateAgency', data)
}

export function deleteAgency(id) {
  return post('/api/services/app/Agency/DeleteAgency', id)
}
export function importAgency(data, time) {
  return post('/api/services/app/Agency/ImportData', data, time)
}

//OperationLogs
export function GetAllOperationLogs(data) {
  return get(`/api/services/app/OperationLogs/GetAll?MaxResultCount=${data.maxResultCount}&SkipCount=${data.skipCount}&Keywords=${data.keywords}&StartTime=${data.startTime}&EndTime=${data.endTime}&LogType=${data.logType}&UserName=${data.userName}`);
}

export function GetAllLoginLogs(data) {
  return get(`/api/services/app/OperationLogs/GetAllLoginLog?MaxResultCount=${data.maxResultCount}&SkipCount=${data.skipCount}&Keywords=${data.keywords}&StartTime=${data.startTime}&EndTime=${data.endTime}&LogType=${data.logType}&UserName=${data.userName}`);
}

//eletricityInfo
export function GetAllElectricInfo(data) {
  return get(`/api/services/app/ElectricInfo/GetAll?sorting=id&MaxResultCount=10&SkipCount=${data}`);
}

//Factory
export function getFactoryAll(FilterText = "", Sorting = 'id ASC', MaxResultCount = 6, SkipCount = 0) {
  return get(`/api/services/app/Building/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`);
}

export function getFactoryAlls(FilterText = "", Sorting = 'id ASC', MaxResultCount = 6, SkipCount = 0) {
  return get(`/api/services/app/Factory/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`);
}

export function GetByCityId(cityId) {
  return get(`/api/services/app/Factory/GetByCityId?cityId=${cityId}`);

}

export function addFactory(data) {
  return post(`/api/services/app/Factory/Create`, data)
}

export function editFactory(data) {
  return put(`/api/services/app/Factory/Update`, data);
}

//Building
export function GetByFactoryId(FactoryId) {
  return get(`/api/services/app/Building/GetByFactoryId?factoryId=${FactoryId}`)
}

//Floor
export function GetByBuildingId(BuildingId) {
  return get(`/api/services/app/Floor/GetByBuildId?buildId=${BuildingId}`)
}
export function GetAllBuilding(FilterText = "", Sorting = 'id ASC', MaxResultCount = 6, SkipCount = 0) {
  return get(`/api/services/app/Building/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`)
}

export function editFloor() {

}

export function deleteBuilding(data) {
  return post(`/api/services/app/Building/Delete`, data)
}

//Laboratory
export function getLabAll(FilterText = "", Sorting = 'id ASC', MaxResultCount = 6, SkipCount = 0) {
  return get(`/api/services/app/Laboratory/GetAll?&FilterText=${FilterText}&Sorting=${Sorting}&MaxResultCount=${MaxResultCount}&SkipCount=${SkipCount}`);
}

export function editLab(data) {
  return put(`/api/services/app/Laboratory/Update`, data);
}

export function deleteLab(data) {
  return axiosDelete(`/api/services/app/Laboratory/Delete`, data)
}

export function addLab(data) {
  return post(`/api/services/app/Laboratory/Create`, data)
}

//Device
export function getDeviceByLabId(LabId = "") {
  return get(`/api/services/app/Device/GetElectricDeviceListByLabId?&LabId=${LabId}`);
}

export function authenticate(data) {
  data.BrandCode = Globals.VUE_APP_Brand;
  return post('/api/TokenAuth/AuthenticateWeb', data);
}
export function refreshUserToken() {
  return post('/api/TokenAuth/RefreshUserToken');
}

export function getSamlRequestUrl(brand, page, dsn) {
  return get(`/api/SamlSso/GetSamlRequest?brand=${brand}&page=${page}&dsn=${dsn}`);
}

export function getSamlLogoutRequest(brand,u) {
  return get(`/api/SamlSso/GetSamlLogoutRequest?brand=${brand}&userName=${u}`);
}

export function getSsoLoginInfo() {
  return get(`/api/SamlSso/GetSsoLoginInfo`);
}

export function getSsoLoginInfo2(data) {
  return get(`/api/SamlSso/GetSsoLoginInfo?userName=${data}`);
}

export function getAllCustomer() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CustomerService/GetCustomers?brand=${brand}`)
}
export function getCustomerOptions(searchKey, productLine , bigRegionId) {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CustomerService/GetCustomerOptions?brand=${brand}&searchKey=${searchKey}&productLine=${productLine}&bigRegionId=${bigRegionId}`)
}
export function getDeviceOptions(dsn, productLine , bigRegionId) {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/DeviceService/GetDeviceOptions?brand=${brand}&dsn=${dsn}&productLine=${productLine}&bigRegionId=${bigRegionId}`)
}
export function getExportCustomerList(data) {
  data.Brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post('/api/services/app/CustomerService/GetExportCustomerList', data)
}
export function getUserCustomerList() {
  return get('/api/services/app/CustomerService/GetUserCustomerList')
}

export function getUserCustomerAndAgencyList() {
  return get('/api/services/app/CustomerService/GetUserCustomerAndAgencyList')
}
export function getCustomerList(custName) {
  custName.Brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post('/api/services/app/CustomerService/GetCustomerList', custName)
}

export function getCustById(id) {
  return post('/api/services/app/CustomerService/GetCustomerById', id)
}
export function getDeviceCustomerById(id) {
  return post('/api/services/app/CustomerService/GetDeviceCustomerById', id)
}

export function getCustomerListByData(Data) {
  Data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post('/api/services/app/CustomerService/GetCustomerListByData', Data)
}
export function addCustomer(data) {
  return post('/api/services/app/CustomerService/AddCustomer', data)
}

export function deleteCustomer(id) {
  return post('/api/services/app/CustomerService/DeleteCustomer', id)
}
export function updateCustomer(data) {
  return post('/api/services/app/CustomerService/UpdateCustomer', data)
}
export function importCustomer(data, time) {
  return post('/api/services/app/CustomerService/ImportCustomer', data, time)
}
//省市
export function getRegionTree() {
  return get('/api/services/app/Region/GetRegionTree')
}
export function getRegionTreeByOfficeId(data) {
  return post('/api/services/app/Region/GetRegionTreeByOfficeId', data)
}

export function GetAllDevice() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/DeviceService/GetDevices?brand=${brand}`)
}
export function GetUserDevices() {
  return get('/api/services/app/DeviceService/GetUserDevices')
}
export function GetUserDeviceModels() {
  return get('/api/services/app/DeviceService/GetUserDeviceModels')
}
export function getDeviceModels() {
  return get('/api/services/app/DeviceModelService/GetDeviceModels')
}
export function pushEnergyParameter(data) {
  return post('/api/services/app/DeviceService/PushEnergyParameter', data)
}
export function getDeviceModelOption() {
  return get('/api/services/app/DeviceModelService/GetDeviceModelOption')
}
export function getDeviceList(data) {
  data.brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post('/api/services/app/DeviceService/GetDeviceList', data)
}

export function GetDeviceLoadedRateListByMonth(data) {
  return post('/api/services/app/DeviceUseRate/GetDeviceLoadedRateListByMonth', data)
}
export function getDeviceByDsn(data, gsn) {
  return get(`/api/services/app/DeviceService/GetDeviceByDsn?dsn=${data}`)
}
export function getDeviceByDsnWeb(data, gsn) {
  return get(`/api/services/app/DeviceService/GetDeviceByDsnWeb?dsn=${data}&gsn=${gsn}`)
}
export function getExportDeviceList(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post('/api/services/app/DeviceService/GetExportDeviceList', data)
}
export function getPreMaintainList(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post('/api/services/app/DeviceService/GetPreMaintainList', data)
}
export function getPreMaintainListForWeb(data) {
  return post('/api/services/app/DeviceService/GetPreMaintainListForWeb', data)
}
export function getDeviceById(id) {
  return post('/api/services/app/DeviceService/GetDeviceById', id)
}
export function getDevicesByCustomer(id) {
  return post('/api/services/app/DeviceService/GetDevicesByCustomer', id)
}
export function getDsnListByCustomer(customerId) {
  return get(`/api/services/app/DeviceService/GetDsnListByCustomerId?customerId=${customerId}`)
}
export function getDevicesByCustomerList(data) {
  return post('/api/services/app/DeviceService/GetDevicesByCustomerList', data)
}

export function GetDevicesByCustomerAndAgencyList(data) {
  return post('/api/services/app/DeviceService/GetDevicesByCustomerAndAgencyList', data)
}

export function addDevice(data) {
  return post('/api/services/app/DeviceService/AddDevice', data)
}
export function deleteDevice(id) {
  return post('/api/services/app/DeviceService/DeleteDevice', id)
}
export function updateDevice(data) {
  return post('/api/services/app/DeviceService/UpdateDevice', data)
}
export function updateDeviceAlarmContacts(data) {
  return post('/api/services/app/DeviceService/UpdateDeviceAlarmContacts', data)
}

export function deviceBindGateway(data) {
  return post('/api/services/app/DeviceService/DeviceBindGateway', data)
}
export function relieveBindGateway(id) {
  return post('/api/services/app/DeviceService/RelieveBindGateway', id)
}
export function importMuCcnFile(Data, time) {
  return post('/api/services/app/DeviceService/ImportMuCcnFile', Data, time)
}
export function importMuDealCcnFile(Data, time) {
  return post('/api/services/app/DeviceService/ImportMuDealCcnFile', Data, time)
}
export function importDevice(Data, time) {
  return post('/api/services/app/DeviceService/ImportDevice', Data, time)
}
export function importServiceType(Data, time) {
  return post('/api/services/app/DeviceService/importServiceType', Data, time)
}
export function getDeviceRate_new(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/DeviceService/GetDeviceRate_new`, data)
}
export function getStatisticsData(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post(`/api/services/app/DeviceService/GetStatisticsData`, data)
}
export function getUtilizationRate_new(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post(`/api/services/app/DeviceService/GetUtilizationRate_new`, data)
}
export function getUtilizationRate_new2(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post(`/api/services/app/DeviceService/GetUtilizationRate_new2`, data)
}

export function getUtilizationRate(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post(`/api/services/app/DeviceService/GetUtilizationRate`, data)
}
export function getIndustryUtilizationRate(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post(`/api/services/app/DeviceService/GetIndustryUtilizationRate`, data)
}
export function getOverallTrendUtilizationRate(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post(`/api/services/app/DeviceService/GetOverallTrendUtilizationRate`, data)
}

export function getServiceTypeList() {
  return get(`/api/services/app/DeviceService/GetServiceTypeList`)
}
export function getRelieveDevices(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post(`/api/services/app/DeviceService/GetRelieveDevices`, data)
}
export function getDeviceLocation(dsn) {
  return get(`/api/services/app/DeviceService/GetDeviceLocation?dsn=${dsn}`)
}
export function getDeviceGatherList(dsn) {
  return get(`/api/services/app/DeviceService/GetDeviceGatherList?dsn=${dsn}`)
}

export function getDeviceUseRateList(dsn, gsn) {
  return get(`/api/services/app/DeviceUseRate/GetDeviceUseRateList?dsn=${dsn}&gsn=${gsn}`)
}
export function getDeviceLoadedRateList(dsn, gsn) {
  return get(`/api/services/app/DeviceUseRate/GetDeviceLoadedRateList?dsn=${dsn}&gsn=${gsn}`)
}
export function getDeviceLoadedChangeList(dsn, gsn) {
  return get(`/api/services/app/DeviceUseRate/GetDeviceLoadedChangeRateList?dsn=${dsn}&gsn=${gsn}`)
}

export function getDeviceUseLoadRateByDsnList(data) {
  return post(`/api/services/app/DeviceUseRate/GetDeviceUseLoadRateByDsnList`,data)
}
export function getCcnInfos(ccn, version, brand, ccnType) {
  if (version == undefined)
    version = "";
  brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/CcnService/GetCcnInfos?ccn=${ccn}&version=${encodeURIComponent(version)}&brand=${brand}&ccnType=${ccnType}`)
}
export function getCcnInfosPage(ccn, version, brand, ccnType, skip, maxResultCount) {
  if (version == undefined)
    version = "";
  brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/CcnService/GetCcnInfosPage?ccn=${ccn}&version=${encodeURIComponent(version)}&brand=${brand}&ccnType=${ccnType}&SkipCount=${skip}&MaxResultCount=${maxResultCount}`)
}

export function getCcnInfosDistinct(ccn) {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/CcnService/GetCcnInfosDistinct?ccn=${ccn}&brand=${brand}`)
}
export function getCcnInfosWithType() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/CcnService/GetCcnInfosWithType?brand=${brand}`)
}
//客户端
export function getCcnInfosForWeb(ccn, version) {
  if (version == undefined)
    version = "";
  return get(`/api/services/app/CcnService/GetCcnInfosForWeb?ccn=${ccn}&version=${encodeURIComponent(version)}`)
}
export function getCcnInfosDistinctForWeb(ccn) {
  return get(`/api/services/app/CcnService/GetCcnInfosDistinctFoeWeb?ccn=${ccn}`)
}

export function getCcnVersionList(ccnType) {
  return get(`/api/services/app/CcnService/GetCcnVersionList?ccnType=${ccnType}`)
}
export function getPacGatherListByModel(modelCode) {
  return get(`/api/services/app/CcnService/GetPacGatherListByModel?modelCode=${modelCode}`)
}
export function getGatherInfos(gatherType) {
  return get(`/api/services/app/CcnService/GetGatherInfos?gatherType=${gatherType}`)
}
export function getGatherUnitList(gatherType) {
  return get(`/api/services/app/CcnService/GetGatherUnitList?gatherType=${gatherType}`)
}
export function getGatherDataTypeList(gatherType) {
  return get(`/api/services/app/CcnService/GetGatherDataTypeList?gatherType=${gatherType}`)
}
export function getExportGatherInfos(gatherType, ccnModel, gatherName, rateType) {
  return get(`/api/services/app/CcnService/GetExportGatherInfos?gatherType=${gatherType}&ccnModel=${ccnModel}&gatherName=${gatherName}&rateType=${rateType}`)
}
export function getGatherInfosForWeb(gatherType) {
    if(gatherType){
      return get(`/api/services/app/CcnService/GetGatherInfosForWeb?gatherType=${gatherType}`)
    }
    else{  
      return get(`/api/services/app/CcnService/GetGatherInfosForWeb`)
    }
}
export function getMonitorGathers() {
  return get(`/api/services/app/CcnService/GetMonitorGathers`)
}
export function getGatherInfosByCcn(ccn, version, gatherType) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CcnService/GetGatherInfosByCcn?ccn=${ccn}&version=${encodeURIComponent(version)}&gatherType=${gatherType}&brandCode=${brandCode}`)
}
export function getCcnGatherList(ccn, version) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CcnService/GetCcnGatherList?ccn=${ccn}&version=${encodeURIComponent(version)}&brandCode=${brandCode}`)
}
export function getCcnGatherListById(id) {
  return get(`/api/services/app/CcnService/GetCcnGatherListById?ccnId=${id}`)
}

export function getCcnGather(ccn, version) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CcnService/GetCcnGather?ccn=${ccn}&version=${encodeURIComponent(version)}&brandCode=${brandCode}`)
}
export function getCcnExportInfo(ccn, version, ccnType) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CcnService/GetCcnExportInfo?ccn=${ccn}&version=${encodeURIComponent(version)}&brandCode=${brandCode}&ccnType=${ccnType}`)
}
export function getCcnExportInfoList(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CcnService/GetCcnExportInfoList`, data)
}

export function getCcnGatherListForWeb(ccn, version) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CcnService/GetCcnGatherListForWeb?ccn=${ccn}&version=${encodeURIComponent(version)}&brandCode=${brandCode}`)
}
export function addCcnGather(data) {
  return post('/api/services/app/CcnService/AddCcnGather', data)
}
export function editCcnGather(data) {
  return post('/api/services/app/CcnService/EditCcnGather', data)
}
export function pushGatherTable(data) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  data.brandCode = brandCode;
  return post('/api/services/app/CcnService/PushGatherTable', data)
}
export function pushGatherTablePac(data) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  data.brandCode = brandCode;
  return post('/api/services/app/CcnService/PushGatherTablePac', data)
}
// export function exportCcn(data) {
//   return post('/api/services/app/CcnService/ExportCcn', data)
// }
export function deleteCcnInfoById(data) {
  return post('/api/services/app/CcnService/DeleteCcnInfoById', data)
}
export function deleteGather(data) {
  return post('/api/services/app/CcnService/DeleteGatherById', data)
}
export function addGather(data) {
  return post('/api/services/app/CcnService/AddGather', data)
}
export function updateGather(data) {
  return post('/api/services/app/CcnService/UpdateGather', data)
}

export function importCcnInfos(data) {
  return post('/api/services/app/CcnService/ImportCcnInfos', data)
}
export function importCcnInfosPac(data) {
  return post('/api/services/app/CcnService/ImportCcnInfosPac', data)
}

export function importExpertAdvices(data) {
  return post('/api/services/app/CcnService/ImportExpertAdvices', data)
}

export function saveGatherList(data) {
  return post('/api/services/app/CcnService/SaveGatherList', data)
}
export function getCcnWithVersionList() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CcnService/GetCcnWithVersionList?brand=${brandCode}`)
}

export function createGatherUnitCalc(data) {
  return post('/api/services/app/GatherUnitCalc/CreateGatherUnitCalc', data)
}
export function deleteGatherUnitCalc(data) {
  return get(`/api/services/app/GatherUnitCalc/DeleteGatherUnitCalc?id=${data}`)
}
export function editGatherUnitCalc(data) {
  return post('/api/services/app/GatherUnitCalc/EditGatherUnitCalc', data)
}
export function getGatherUnitCalcList(data) {
  return get(`/api/services/app/GatherUnitCalc/GetGatherUnitCalcList?SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}`)
}
export function getGatherUnitCalc(data) {
  return get(`/api/services/app/GatherUnitCalc/GetGatherUnitCalc?id=${data}`)
}

export function getDeviceModelTable() {
  return get('/api/services/app/DeviceModelService/GetDeviceModelTable')
}
export function getDeviceModelTablePage(data) {
  data.brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post('/api/services/app/DeviceModelService/GetDeviceModelTablePage', data)
}
export function getDeviceModelById(id) {
  return post('/api/services/app/DeviceModelService/GetDeviceModelById', id)
}
export function deleteDeviceModel(data) {
  return post('/api/services/app/DeviceModelService/DeleteDeviceModel', data)
}
export function updateDeviceModel(data) {
  return post('/api/services/app/DeviceModelService/UpdateDeviceModel', data)
}
export function addDeviceModel(data) {
  return post('/api/services/app/DeviceModelService/AddDeviceModel', data)
}

export function importDeviceModel(data) {
  return post('/api/services/app/DeviceModelService/ImportDeviceModel', data)
}

export function addDeviceModel222(data) {
  return post('/api/services/app/DeviceModelService/AddDeviceModelWithImg', data)
}

export function getProductFamilyList() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/DeviceModelService/GetProductFamilyList?brandCode=${brand}`)
}
export function getDeviceModelType() {
  return get('/api/services/app/DeviceModelService/GetDeviceModelType')
}
export function getProductLines() {
  return get('/api/services/app/DeviceModelService/GetProductLines')
}

export function getCustomerRegionTable() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CustomerRegionService/GetCustomerRegionTable?brand=${brand}`)
}
export function GetCustomerRegions() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/CustomerRegionService/GetCustomerRegions?brand=${brand}`)
}
export function getCustomerRegionById(id) {
  return post('/api/services/app/CustomerRegionService/GetCustomerRegionById', id)
}
export function deleteCustomerRegion(data) {
  return post('/api/services/app/CustomerRegionService/DeleteCustomerRegion', data)
}
export function updateCustomerCenter(data) {
  return post('/api/services/app/CustomerRegionService/UpdateCustomerCenter', data)
}
export function getCustomerRegionList() {
  return get('/api/services/app/CustomerRegionService/GetCustomerRegionList')
}
export function addRangeCustomerRegion(data) {
  return post('/api/services/app/CustomerRegionService/AddRangeCustomerRegion', data)
}
export function addCustomerCenter(data) {
  return post('/api/services/app/CustomerRegionService/AddCustomerCenter', data)
}
export function deleteRangeCustomerRegion(id) {
  return post('/api/services/app/CustomerRegionService/DeleteRangeCustomerRegion', id)
}
export function getCustomerRegionTree() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CustomerRegionService/GetCustomerRegionTree?brand=${brand}`)
}
export function getAllCustomerRegionTree() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CustomerRegionService/GetAllCustomerRegionTree?brand=${brand}`)
}
export function getBrandCustomerRegionTree() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/CustomerRegionService/GetBrandCustomerRegionTree?brand=${brand}`)
}
export function GetCustomerCenterTree() {
  return get('/api/services/app/CustomerRegionService/GetCustomerCenterTree',)
}
export function getCustomerCenterType() {
  return get('/api/services/app/CustomerRegionService/GetCustomerCenterType')
}
export function getDeviecModelTree(type) {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/DeviceModelService/GetDeviceModelTree?type=${type}&brand=${brand}`)
}
//城市
export function addCustomerCity(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post('/api/services/app/CustomerCity/AddCustomerCity', data)
}
export function deleteCustomerCity(data) {
  return post('/api/services/app/CustomerCity/DeleteCustomerCity', data)
}
export function getCustomerCityList(data) {
  return post('/api/services/app/CustomerCity/GetCustomerCityList', data)
}

//客户账号
export function customerAccountCreate(data) {
  return post("/api/services/app/CustomerAccountService/Create", data)
}

export function customerAccountGetAll(data) {
  data.Brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/CustomerAccountService/GetAll?Keyword=${data.Keyword}&Brand=${data.Brand}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}`)
}

export function customerAccountDelete(data) {
  return axiosDelete(`/api/services/app/CustomerAccountService/DeleteCustomer?id=${data}`)
}

export function ResetCoustomerPassword(data) {
  return post("/api/services/app/CustomerAccountService/ResetCoustomerPassword", data)
}

export function UpdateCustomer(data) {
  return put("/api/services/app/CustomerAccountService/UpdateCustomer", data)
}


export function getGateways(gsn) {
  gsn.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post('/api/services/app/GatewayService/GetGateways', gsn)
}
export function getGatewayOption() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/GatewayService/GetGatewayOption?brand=${brand}`)
}
export function GetGatewaysWithoutUse() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/GatewayService/GetGatewaysWithoutUse?brandCode=${brand}`)
}
export function getDigitalTwinData(dsn) {
  return get(`/api/services/app/GatewayService/GetDigitalTwinData?dsn=${dsn}`)
}
export function pushToDigitalTwin(data) {
  return post('api/services/app/GatewayService/PushToDigitalTwin',data)
}
export function getByGsn(gsn) {
  return post('/api/services/app/GatewayService/GetByGsn', gsn)
}
export function addGateway(data) {
  return post('/api/services/app/GatewayService/AddGateway', data)
}
export function deleteGateway(gsn) {
  return post('/api/services/app/GatewayService/DeleteGateway', gsn)
}
export function importGateway(gsn, time) {
  return post('/api/services/app/GatewayService/ImportGateway', gsn, time)
}

export function GetLocationInfo(simNumber) {
  return get(`/api/services/app/GatewayService/GetLocationInfo?msisdn=${simNumber}`)
}

//monitor
export function getMonitorHistory(Data) {
  return post('/api/services/app/GatewayService/GetMonitorHistory', Data)
}
export function getMonitorHistoryForWeb(Data) {
  return post('/api/services/app/GatewayService/GetMonitorHistoryForWeb', Data)
}
export function getMonitorHistoryByGsn(data) {
  return post(`/api/services/app/GatewayService/GetMonitorHistoryByGsn`, data)
}
export function getMonitorHistoryByGsnForWeb(data) {
  return post(`/api/services/app/GatewayService/GetMonitorHistoryByGsnForWeb`, data)
}
export function getMonitorReal(Data) {
  return post('/api/services/app/GatewayService/GetMonitorReal', Data)
}
export function getMonitorRealForWeb(Data) {
  return post('/api/services/app/GatewayService/GetMonitorRealForWeb', Data)
}
export function CreateRealTimeShadow(Data) {
  return post('/api/services/app/GatewayService/CreateRealTimeShadow', Data)
}
export function getDeviceData(Data) {
  return post('/api/services/app/GatewayService/GetDeviceData', Data)
}
export function getDeviceDataForWeb(Data) {
  return post('/api/services/app/GatewayService/GetDeviceDataForWeb', Data)
}
export function getDeviceDataForGsn(Data) {
  return post('/api/services/app/GatewayService/GetDeviceDataForGsn', Data)
}
export function getDeviceDataForGsnForWeb(Data) {
  return post('/api/services/app/GatewayService/GetDeviceDataForGsnForWeb', Data)
}
export function getTripWarningMonitor(Data) {
  return get(`/api/services/app/GatewayService/GetTripWarningMonitor?alarmID=${Data}`)
}
export function exportTripWarningMonitor(Data) {
  return get(`/api/services/app/GatewayService/ExportTripWarningMonitor?alarmID=${Data}`)
}
export function exportTripWarningMonitorHalf(Data) {
  return get(`/api/services/app/GatewayService/ExportTripWarningMonitor?alarmID=${Data}&type=half`)
}
export function exportTripWarningMonitor2(Data) {
  return get(`/api/services/app/GatewayService/ExportTripWarningMonitor2?alarmID=${Data}`)
}
export function getLatestMonitorDataProcess(Data) {
  return post(`/api/services/app/GatewayService/GetLatestMonitorDataProcess`, Data)
}
export function getMonday10Data(Data) {
  Data.brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post(`/api/services/app/GatewayService/GetMonday10Data`, Data)
}
export function getAlarmMonitor(alarmId) {
  return get(`/api/services/app/GatewayService/GetAlarmMonitor?alarmId=${alarmId}`)
}
export function getMaintainRecord(dsn) {
  return get(`/api/services/app/DeviceService/GetMaintainRecord?dsn=${dsn}`)
}

//menu
export function CreateMenu(data) {
  return post(`/api/services/app/Menu/CreateMenu`, data)
}

export function GetAllMenus(data) {
  return get(`/api/services/app/Menu/GetAllMenus`)
}

export function AddMenuToRole(data) {
  return post(`/api/services/app/Menu/AddMenuToRole`, data)
}

export function DeleteMenu(data) {
  return axiosDelete(`/api/services/app/Menu/Delete`, data)
}

export function UpdateMenu(data) {
  return put(`/api/services/app/Menu/Update`, data)
}

export function GetMenus(data) {
  return get(`/api/services/app/Menu/GetMenus`)
}

export function GetUserMenu() {
  return get(`/api/services/app/Menu/GetUserValidMenu`)
}

//Role_set
export function getRoles(Keyword = "", SkipCount = 0, MaxResultCount = 10) {
  return get(`/api/services/app/Role/GetRoles?Keyword=${Keyword}&SkipCount=${SkipCount}&MaxResultCount=${MaxResultCount}`)
}

export function addRoles(data) {
  return post(`/api/services/app/Role/Create`, data)
}

export function updateRoles(data) {
  return put(`/api/services/app/Role/Update`, data)
}

export function UpdateRoleDataPermissionList(data) {
  return put(`/api/services/app/Role/UpdateRoleDataPermissionList`, data)
}

export function deleteRole(id) {
  return axiosDelete(`/api/services/app/Role/Delete?id=${id}`)
}

export function getAllRoles(Keyword = "", SkipCount = 0, MaxResultCount = 0) {
  return get(`/api/services/app/Role/GetAll?Keyword=${Keyword}&SkipCount=${SkipCount}&MaxResultCount=${MaxResultCount}`)
}

export function getAllRole() {
  return get(`/api/services/app/Role/GetAll`)
}

export function GetUserDatapermission(data) {
  return get(`/api/services/app/Role/GetUserDatapermission?UserId=${data}`)
}

export function GetUserRoleDatapermission(data) {
  return get(`/api/services/app/Role/GetUserRoleDatapermission?UserId=${data.UserId}&RoleId=${data.RoleId}`)
}

export function GetUserRoleListDatapermission(data) {
  return get(`/api/services/app/Role/GetUserRoleListDatapermission?UserId=${data}`)
}

export function GetAllPermissions() {
  return get(`/api/services/app/Role/GetAllPermissions`)
}

export function RolePermissionSet(data) {
  return post(`/api/services/app/Role/RolePermissionSet`, data)
}

//ClientStatService
export function GetDeviceStatData() {
  return get(`/api/services/app/ClientStatService/GetDeviceStatData`)
}
export function GetIndustryRateSum() {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/StatService/GetIndustryRateSum?brandCode=${brand}`)
}
export function GetRateSumByMonthRange(data) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  data.BrandCode = brandCode;
  return post(`/api/services/app/StatService/GetRateSumByMonthRange`, data)
}

export function GetIndustryRateTop() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/StatService/GetIndustryRateTop?brandCode=${brandCode}`)
}

export function GetKPIStat(bigRegionId, customerCenterId, productLine) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/StatService/GetKPIStat?bigRegionId=${bigRegionId}&customerCenterId=${customerCenterId}&brandCode=${brandCode}&productLine=${productLine}`)
}

export function GetKPIStatDeviceList(data) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  data.brandCode = brandCode;
  return post(`/api/services/app/StatService/GetKPIStatDeviceList`, data)
}
// export function GetKPIStatDeviceListForWeb(data) {
//   var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
//   data.brandCode = brandCode;
//   return post(`/api/services/app/StatService/GetKPIStatDeviceListForWeb`, data)
// }

export function GetExportKPIStatDeviceList(data) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  data.brandCode = brandCode;
  return post(`/api/services/app/StatService/GetExportKPIStatDeviceList`, data)
}
export function getRunningTimeList(data) {
  return post(`/api/services/app/StatService/GetRunningTimeList`, data)
}
export function getS3FileList(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/StatService/GetS3FileList`, data)
}
export function getS3FileListByCustomer(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/StatService/GetS3FileListByCustomer`, data)
}
export function getInstallReportList(data) {
  return post(`/api/services/app/StatService/GetInstallReportList`, data)
}
export function getInstallReportData(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/StatService/GetInstallReportData`, data)
}

//User
export function getUser(Keyword = "", IsActive = true, SkipCount = 0, MaxResultCount = 0) {
  return get(`/api/services/app/User/GetAll?Keyword=${Keyword}&IsActive=${IsActive}&SkipCount=${SkipCount}&MaxResultCount=${MaxResultCount}`)
}
export function getUserByDto(data) {
  return post(`/api/services/app/User/GetAllByDto`, data)
}

export function addUser(data) {
  return post(`/api/services/app/User/Create`, data)
}

export function UpdateUser(data) {
  return put(`/api/services/app/User/Update`, data)
}

export function deleteUser(data) {
  return axiosDelete(`/api/services/app/User/Delete?Id=${data}`)
}
export function changePassword(data) {
  return post(`/api/services/app/User/ChangePassword`, data)
}
export function resetPassword(data) {
  return post(`/api/services/app/User/ResetPassword`, data)
}
export function logout() {
  return post(`/api/services/app/User/Logout`)
}

export function relieveLock(data) {
  return post(`/api/services/app/User/RelieveLock`, data)
}

export function getUserByIdAsync(UserId = "") {
  return get(`/api/services/app/User/GetUserById?UserId=${UserId}`)
}
export function getUserBrand() {
  return get(`/api/services/app/User/GetUserBrand`)
}
export function getUserAccountType() {
  return get(`/api/services/app/User/GetUserAccountType`)
}

export function getPasswordLogs(data) {
  return post(`/api/services/app/User/GetPasswordLogs`, data)
}
export function getUserDeviceList(data) {
  return get(`/api/services/app/User/GetUserDeviceList?UserName=${data.userName}&Dsn=${data.dsn}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}`)
}
export function addUserDeviceRel(data) {
  return post(`/api/services/app/User/AddUserDeviceRel`, data)
}
export function deleteUserDeviceRel(id) {
  return axiosDelete(`/api/services/app/User/DeleteUserDeviceRel?Id=${id}`)
}
export function getSfaUserList() {
  return get(`/api/services/app/User/GetSfaUserList`)
}
export function importUserDeviceRel(data) {
  return post(`/api/services/app/User/importUserDeviceRel`, data)
}
export function updateSyncSfaEnable(data) {
  return put(`/api/services/app/User/UpdateSyncSfaEnable`, data)
}
export function getSfaUserBindDevices(data) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/User/GetSfaUserBindDevices?userId=${data.userId}&brandCode=${brandCode}&language=${data.language}&skipCount=${data.skipCount}&maxResultCount=${data.maxResultCount}`)
}
export function getSEList() {
  return get(`/api/services/app/User/GetSEList`)
}
export function getSSEList() {
  return get(`/api/services/app/User/GetSSEList`)
}
export function getDealerList() {
  return get(`/api/services/app/User/GetDealerList`)
}
//行业
export function getIndustryTree(type) {
  return get(`/api/services/app/Industry/GetIndustryTree?type=${type}`,)
}

export function GetHomeStat() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/StatService/GetHomeStat?brandCode=${brandCode}`)
}

export function GetHomeDeviceStat() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/StatService/GetHomeDeviceStat?brandCode=${brandCode}`)
}
//客户端接口
export function getHomeDeviceStatForWeb() {
  return get(`/api/services/app/StatService/GetHomeDeviceStatForWeb`)
}
export function getHomeHealthStatForWeb() {
  return get(`/api/services/app/StatService/GetHomeHealthStatForWeb`)
}
export function getHealthRateTrendForWeb() {
  return get(`/api/services/app/StatService/GetHealthRateTrendForWeb`)
}
export function getIndustryRateSumForWeb() {
  return get(`/api/services/app/StatService/GetIndustryRateSumForWeb`)
}
export function getIndustryRateTopForWeb() {
  return get(`/api/services/app/StatService/GetIndustryRateTopForWeb`)
}

export function GetHomeHealthStat() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/StatService/GetHomeHealthStat?brandCode=${brandCode}`)
}

export function GetHomeRegisterStat() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/StatService/GetHomeRegisterStat?brandCode=${brandCode}`)
}
//statService
export function GetCountryStat() {
  return get('/api/services/app/StatService/GetCountryStat')
}
export function GetBigRegionStat() {
  return get('/api/services/app/StatService/GetBigRegionStat')
}

//首页头部数据
export function GetDeviceStatByRegion(data) {
  // return get(`/api/services/app/StatService/GetDeviceStatByRegion?Type=${data.type}&${qs.stringify({RegionNameList:data.regionNameList},{ indices: false })}`)
  return post(`/api/services/app/StatService/GetDeviceStatByRegion`, data)
}
export function GetCityStatByBigRegion(data) {
  // return get(`/api/services/app/StatService/GetDeviceStatByRegion?Type=${data.type}&${qs.stringify({RegionNameList:data.regionNameList},{ indices: false })}`)
  return get(`/api/services/app/StatService/GetCityStatByBigRegion?regionName=${data}`,)
}
export function GetDeviceStatByCity(data) {
  return get(`/api/services/app/StatService/GetDeviceStatByCity?cityName=${data}`)
  // return post(`/api/services/app/StatService/GetDeviceStatByCity`,data)
}
export function GetMapList(data) {
  return get(`/api/services/app/CustomerRegionService/GetMapList`)
}
export function GetHealthRateTrend() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/StatService/GetHealthRateTrend?brandCode=${brandCode}`)
}
export function GetAlarmTrendData(type, regionName) {
  return get(`/api/services/app/StatService/GetAlarmTrendData?type=${type}&regionName=${regionName}`)
}
export function GetAlarmTrendDataByCustomer(type) {
  return get(`/api/services/app/StatService/GetAlarmTrendDataByCustomer?type=${type}`)
}
export function CalcWaitServiceHistoryData(regionName) {
  return get(`/api/services/app/StatService/CalcWaitServiceHistoryData?regionName=${regionName}`)
}
export function CalcExpireServiceData(regionName) {
  return get(`/api/services/app/StatService/CalcExpireServiceData?regionName=${regionName}`)
}

//AlarmRuleService 告警
export function GetAllAlarmRules(data) {
  data.brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/AlarmRuleService/GetAllAlarmRules?CustomerRegionId=${data.customerRegionId}&CustomerCenterRegionId=${data.customerCenterRegionId}&ProductLine=${data.productLine}&SkipCount=${data.skipCount}&MaxResultCount=10&BrandCode=${data.brandCode}`)
}
export function CreateAlarmRules(data) {
  return post('/api/services/app/AlarmRuleService/CreateAlarmRules', data)
}
export function UpdateAlarmRules(data) {
  return put('/api/services/app/AlarmRuleService/UpdateAlarmRules', data)
}
export function DeleteAlarmRules(data) {
  return axiosDelete(`/api/services/app/AlarmRuleService/DeleteAlarmRules?Id=${data}`)
}
export function GetAllManererUser() {
  return post(`/api/services/app/AlarmRuleService/GetAllManererUser`)
}
export function GetAlarmService(data) {
  let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/AlarmService/GetAll?CustomerRegionId=${data.customerRegionId}&CustomerCenterRegionId=${data.customerCenterRegionId}&AlarmType=${data.alarmType}&AlarmStatus=${data.alarmStatus}&GsnCode=${data.gsnCode}&StartTime=${data.startTime}&EndTime=${data.endTime}&SnCode=${data.snCode}&CustomerId=${data.customerId}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}&PageFlag=${data.pageFlag}&IsContainWJ=${data.isContainWJ}&BrandCode=${brand}&ProductLine=${data.productLine}&DateType=${data.dateType}`)
}
export function GetAlarmServiceForWeb(data) {
  return get(`/api/services/app/AlarmService/GetAllForWeb?CustomerRegionId=${data.customerRegionId}&ModelId=${data.modelId}&CustomerCenterRegionId=${data.customerCenterRegionId}&AlarmType=${data.alarmType}&AlarmStatus=${data.alarmStatus}&GsnCode=${data.gsnCode}&StartTime=${data.startTime}&EndTime=${data.endTime}&SnCode=${data.snCode}&CustomerId=${data.customerId}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}&PageFlag=${data.pageFlag}&IsContainWJ=${data.isContainWJ}&ProductLine=${data.productLine}`)
}
export function WebGetAlarmService(data) {
  return get(`/api/services/app/AlarmService/WebGetAll?CustomerRegionId=${data.customerRegionId}&ModelId=${data.modelId}&CustomerCenterRegionId=${data.customerCenterRegionId}&AlarmType=${data.alarmType}&AlarmStatus=${data.alarmStatus}&GsnCode=${data.gsnCode}&StartTime=${data.startTime}&EndTime=${data.endTime}&SnCode=${data.snCode}&CustomerId=${data.customerId}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}&PageFlag=${data.pageFlag}&IsContainWJ=${data.isContainWJ}&ProductLine=${data.productLine}`)
}
export function getAlarmDetailById(id) {
  return get(`/api/services/app/AlarmService/GetAlarmDetailById?alarmId=${id}`)
}
export function getAlarmByGsn(data) {
  return get(`/api/services/app/AlarmService/GetAlarmByDsn?dsn=${data.dsn}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}&dateType=${data.dateType}`)
}

export function getHealthReportList(data) {
  return get(`/api/services/app/HealthReportService/GetHealthReportList?dsn=${data.dsn}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}&dateType=${data.dateType}`)
}

export function GetHealthReport(reportId) {
  return get(`/api/services/app/HealthReportService/GetHealthReport?reportId=${reportId}`)
}

export function SaveCustomerNotes(reportId, notes) {
  return post(`/api/services/app/HealthReportService/SaveCustomerNotes?reportId=${reportId}&notes=${notes}`)
}

export function GetCustomerHealthReportList(data) {
  return get(`/api/services/app/HealthReportService/GetCustomerHealthReportList?customerId=${data.customerId}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}`)
}

export function GetCustomerHealthReport(reportId) {
  return get(`/api/services/app/HealthReportService/GetCustomerHealthReport?reportId=${reportId}`)
}
export function getMonitorAlarm(data) {
  return get(`/api/services/app/AlarmService/GetMonitorAlarm?gsn=${data.gsn}&start=${data.start}&end=${data.end}`)
}
export function getAlarmByDsnForWeb(data) {
  return get(`/api/services/app/AlarmService/GetAlarmByDsnForWeb?dsn=${data.dsn}&SkipCount=${data.skipCount}&MaxResultCount=${data.maxResultCount}&dateType=${data.dateType}`)
}

export function GetAlarmCount() {
  return get(`/api/services/app/AlarmService/GetAlarmCountByUserId`)
}

export function UpdateRead(data) {
  return post('/api/services/app/AlarmService/UpdateRead', data)
}
//告警推送规则
export function getAlarmPushRules(data) {
  let brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return get(`/api/services/app/AlarmPushRule/GetAlarmPushRules?Keyword=${data.keyword}&SkipCount=${data.skipCount}&MaxResultCount=10&BrandCode=${brandCode}`)
}
export function createAlarmPushRules(data) {
  data.brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post('/api/services/app/AlarmPushRule/CreateAlarmPushRules', data)
}
export function updateAlarmPushRules(data) {
  return post('/api/services/app/AlarmPushRule/UpdateAlarmPushRules', data)
}
export function deleteAlarmPushRules(id) {
  return axiosDelete(`/api/services/app/AlarmPushRule/DeleteAlarmPushRules?id=${id}`)
}
export function getAlarmPushRuleCcn(data) {
  return get(`/api/services/app/AlarmPushRule/GetAlarmPushRuleCcn?id=${data.id}&keyword=${data.keyword}`)
}
export function getAllAlarmPushRuleCcn() {
  return get(`/api/services/app/AlarmPushRule/GetAllAlarmPushRuleCcn`)
}
export function updateAlarmPushCcnRel(data) {
  return post(`/api/services/app/AlarmPushRule/UpdateAlarmPushCcnRel`, data)
}
export function getAlarmPushRuleConditions() {
  return get(`/api/services/app/AlarmPushRule/GetAlarmPushRuleConditions`)
}


//空压站
export function addDeviceStation(data) {
  return post('/api/services/app/DeviceStation/AddDeviceStation', data)
}
export function getDeviceStationList(data) {
  return post('/api/services/app/DeviceStation/GetDeviceStationList', data)
}
export function deleteDeviceStation(data) {
  return post('/api/services/app/DeviceStation/DeleteDeviceStation', data)
}
export function updateDeviceStation(data) {
  return post('/api/services/app/DeviceStation/UpdateDeviceStation', data)
}
export function getDeviceStationById(data) {
  return post('/api/services/app/DeviceStation/getDeviceStationById', data)
}
export function GetDeviceStations() {
  return get('/api/services/app/DeviceStation/GetDeviceStations')
}

export function getDeviceImages(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get('/api/services/app/DeviceImageService/GetDeviceImages', data)
}
export function getDeviceImageList() {
  return get('/api/services/app/DeviceImageService/GetDeviceImageList')
}
export function getDeviceImageById(id) {
  return get('/api/services/app/DeviceImageService/GetDeviceImageById', id)
}
export function addImage(data) {
  return post('/api/services/app/DeviceImageService/AddImage', data)
}
export function updateImage(data) {
  return put('/api/services/app/DeviceImageService/UpdateImage', data)
}
export function deleteImage(data) {
  return post('/api/services/app/DeviceImageService/DeleteImage', data)
}

//customerAccount
export function addCustomerAccount(data) {
  return post(`/api/services/app/CustomerAccountService/Create`, data)
}
export function deleteCustomerAccount(data) {
  return axiosDelete(`/api/services/app/CustomerAccountService/DeleteCustomer?Id=${data}`)
}
export function getCustomerAccount(Keyword = "", SkipCount = 0, MaxResultCount = 0) {
  return get(`/api/services/app/CustomerAccountService/GetAll?Keyword=${Keyword}&SkipCount=${SkipCount}&MaxResultCount=${MaxResultCount}`)
}
export function resetCoustomerPassword(data) {
  return post(`/api/services/app/CustomerAccountService/ResetCoustomerPassword`, data)
}
//商业信息管理发送
export function addMessage(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/Messages/Create`, data)
}

export function getAllMessage(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/Messages/GetAll?Keyword=${data.Keyword}&SkipCount=${data.SkipCount}&MaxResultCount=${data.MaxResultCount}&BrandCode=${data.BrandCode}`)
}

export function getMessageByUser(data) {
  return get(`/api/services/app/Messages/GetPushMessageByUserId?Keyword=${data.Keyword}&SkipCount=${data.SkipCount}&MaxResultCount=${data.MaxResultCount}`)
}

export function GetPushMessageCounts(data) {
  return get(`/api/services/app/Messages/GetPushMessageCounts?Keyword=${data.Keyword}&SkipCount=${data.SkipCount}&MaxResultCount=${data.MaxResultCount}`)
}
export function getMessageById(data) {
  return get(`/api/services/app/Messages/Get?Id=${data.Id}`)
}

//空压机服务
export function getMaintainItemTable(type) {
  return get(`/api/services/app/MaintainItem/GetMaintainItemTable?type=${type}`)
}
export function getMaintainItemConfirmTable(type, runningTime, dsn) {
  return get(`/api/services/app/MaintainItem/GetMaintainItemConfirmTable?type=${type}&runningTime=${runningTime}&Dsn=${dsn}`)
}

export function getMaintainHistoryByDeviceId(deviceId, runningTime) {
  return get(`/api/services/app/MaintainHistory/GetMaintainHistoryByDeviceId?deviceId=${deviceId}&runningTime=${runningTime}`)
}
export function updateMaintainHistorys(data) {
  return post(`/api/services/app/MaintainHistory/UpdateMaintainHistorys`, data)
}
export function updateMaintainHistoryPushs(data) {
  return post(`/api/services/app/MaintainHistory/UpdateMaintainHistoryPushs`, data)
}
export function getMaintainExportData(dsn, runningTime) {
  return get(`/api/services/app/MaintainHistory/GetMaintainExportData?dsn=${dsn}&runningTime=${runningTime}`)
}

export function pushMaintainMsg(data) {
  return post(`/api/services/app/MaintainPushService/PushMaintainMsg`, data)
}


export function addMaintainLose(data) {
  return post(`/api/services/app/MaintainLose/addMaintainLose`, data)
}

export function getAllMaintainRecord(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/MaintainRecord/GetAll`, data)
}
export function importMaintainRecord(data, time) {
  return post(`/api/services/app/MaintainRecord/ImportMaintainRecord`, data, time)
}
export function getMaintainType() {
  return get(`/api/services/app/MaintainRecord/GetMaintainType`)
}

export function exportMaintainRecordStat() {
  let brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/MaintainRecord/ExportMaintainRecordStat?brandCode=${brandCode}`)
}
//设备分析
export function getInsightList(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/InsightService/GetInsightList`, data)
}
export function getInsightChart(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/InsightService/GetInsightChart`, data)
}

export function updateMessage(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return put(`/api/services/app/Messages/Update`, data)
}

export function UpdateMesIsRead(data) {
  return put(`/api/services/app/Messages/UpdateIsRead`, data)
}

export function deleteMessage(data) {
  return axiosDelete(`/api/services/app/Messages/Delete?Id=${data}`)
}

export function sendMessage(data) {
  return post(`/api/services/app/Messages/SendMessages`, data)
}

export function checkLogin() {
  return post(`/api/services/app/Account/CheckLogin`)
}

export function getLogTypeList() {
  return get(`/api/services/app/BnDict/GetAll`)
}
export function getAlarmTranslations(data) {
  return post(`/api/services/app/BnDict/GetAlarmTranslations`, data)
}

export function updateAlarmTranslation(data) {
  return put(`/api/services/app/BnDict/UpdateAlarmTranslation`, data)
}

export function createAlarmTranslation(data) {
  return post(`/api/services/app/BnDict/CreateAlarmTranslation`, data)
}
export function deleteAlarmTranslation(id) {
  return axiosDelete(`/api/services/app/BnDict/DeleteAlarmTranslation?id=${id}`)
}


//重置密码验证码-检验邮箱是否存在
export function checkEmailExist(data) {
  return post(`/api/services/app/User/CheckEmailExist`, data)
}

//发送验证码
export function sendVerCode(data) {
  return post(`/api/services/app/User/SendVerificationCode`, data)
}

//忘记重置密码
export function forgetassword(data) {
  return post(`/api/services/app/User/ForgetPassword`, data)
}
//忘记重置密码
export function changeMonitorMode(data) {
  return put(`/api/services/app/User/ChangeMonitorMode`, data)
}

export function getUserInfo() {
  return get(`/api/services/app/User/GetCurrentUserAsync`)
}

export function checkLoginFront() {
  // var apiToken = getItemFormLocalstorage('auth');
  // var curUserInfo = getItemFormLocalstorage('userInfo');
  // if (apiToken == null || curUserInfo == null) {
  //   location.href = "/login";
  // }
  checkLogin().then((res) => {

  }).catch((err) => {
    delCookie("userSessionID");
    delItemFormLocalstorage("userInfo");
    delItemFormLocalstorage("userName");
    delItemFormLocalstorage("auth");
    delItemFormLocalstorage("TokenExpire");
    delItemFormLocalstorage("refreshtime");
    delItemFormLocalstorage("expires_in");
    delItemFormLocalstorage("menuData");
    delItemFormLocalstorage("authOperations");
    delItemFormLocalstorage("AlarmCount");
    delItemFormLocalstorage("isneedchange");
    sessionStorage.clear();
    delCookie("auth");
    delCookie("Abp.AuthToken");

    location.href = "/login";
  });
}

export function checkLoginClient() {
  // var apiToken = getItemFormLocalstorage('auth');
  // var curUserInfo = getItemFormLocalstorage('userInfo');
  // if (apiToken == null || curUserInfo == null) {
  //   location.href = "/clientlogin";
  // }
  checkLogin().then((res) => {

  }).catch((err) => {
    delCookie("userSessionID");
    delItemFormLocalstorage("userInfo");
    delItemFormLocalstorage("userName");
    delItemFormLocalstorage("auth");
    delItemFormLocalstorage("TokenExpire");
    delItemFormLocalstorage("refreshtime");
    delItemFormLocalstorage("expires_in");
    delItemFormLocalstorage("menuData");
    delItemFormLocalstorage("authOperations");
    delItemFormLocalstorage("AlarmCount");
    delItemFormLocalstorage("isneedchange");
    sessionStorage.clear();
    delCookie("auth");
    delCookie("Abp.AuthToken");
    location.href = "/clientlogin";
  });
}
//SIM
export function GetSimStatusNumber() {
  return get(`/api/services/app/CmccWeb/GetSimStatusNumber`)
}
export function GetCurrenSixMonthBill(data) {
  return get(`/api/services/app/CmccWeb/GetCurrenSixMonthBill?monthsNum=${data}`)
}
export function GetBill(data) {
  return get(`/api/services/app/CmccWeb/GetBill?queryDate=${data}`)
}
export function GetUseAmout() {
  return get(`/api/services/app/CmccWeb/GetGroupDataUsage`)
}
export function GetSimDataUsagemonthlyBatch() {
  return get(`/api/services/app/CmccWeb/GetSimDataUsagemonthlyBatch`)
}
export function GetSimDataUsagemDailyBatch() {
  return get(`/api/services/app/CmccWeb/GetSimDataUsageDailyBatch`)
}

export function GetSimInfoDetail(data) {
  return post(`/api/services/app/CmccWeb/GetSimInfoDetail`, data)
}


export function GetDeviceUseRateByUser(type) {
  return get(`/api/services/app/DeviceUseRate/GetDeviceUseRateByUser`)
}

export function addStationInfo(data) {
    return post(`/api/services/app/StationService/AddStationinfo`, data)
}

export function updateStationInfo(data) {
    return post(`/api/services/app/StationService/UpdateStationinfo`, data)
}

export function getAllStationInfo(data) {
  return post(`/api/services/app/StationService/GetAllStationInfo`, data)
}
export function deleteStationInfo(data) {
      return post(`/api/services/app/StationService/DeleteStationinfo?Id=${data}`)
}


//OTA
export function addOTAinfo(data) {
  data.append("BrandCode", localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR");
  return post(`/api/services/app/Ota/Create`, data)
}

export function getAllOTAInfo(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/Ota/GetAll?Name=${data.name}&Type=${data.type}&SkipCount=${data.SkipCount}&MaxResultCount=${data.MaxResultCount}&BrandCode=${data.BrandCode}`)
}

export function creatOTAJob(data) {
  return post(`/api/services/app/Ota/CreatOTAJob`, data)
}

export function getInsightToken(data) {
  return post(`/api/services/app/InsightService/GetInsightToken`, data)
}

export function getInsightToken2(data) {
  return post(`http://71.131.198.41//trusted`, data)
}

export function deleteOTAInfo(data) {
  return axiosDelete(`/api/services/app/Ota/Delete?Id=${data}`)
}

export function updateOtaInfo(data) {
  return put(`/api/services/app/Ota/Update`, data)
}
export function batchCreatOTAJob(data) {
  return post(`/api/services/app/Ota/BatchCreatOTAJob`, data)
}
export function createOtaUpgrade(data) {
  data.append("brandCode", localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR");
  return post(`/api/services/app/Ota/CreateOtaUpgrade`, data)
}
export function updateOtaUpgrade(data) {
  data.append("brandCode", localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR");
  return post(`/api/services/app/Ota/UpdateOtaUpgrade`, data)
}
export function deleteOtaUpgrade(data) {
  return axiosDelete(`/api/services/app/Ota/DeleteOtaUpgrade?Id=${data}`)
}
export function getOtaUpgradeList(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/Ota/GetOtaUpgradeList`, data)
}
export function getOtaInfoList() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/Ota/GetOtaInfoList?brandCode=${brandCode}`)
}
export function saveUpgradeDevices(data) {
  return post(`/api/services/app/Ota/SaveUpgradeDevices`, data)
}
export function pushJobFile(data) {
  return post(`/api/services/app/Ota/PushJobFile`, data)
}
export function pushInstallCommand(data) {
  return post(`/api/services/app/Ota/PushInstallCommand`, data)
}
export function setTimingUpgrade(data) {
  return post(`/api/services/app/Ota/SetTimingUpgrade`, data)
}
export function getProductLineList() {
  let obj1 = { name: "其他", value: "Other" };
  let obj2 = { name: "PAC", value: "PAC" }
  let result = new Array();
  result.push(obj1);
  result.push(obj2);
  return result;
}
// export function getOtaDetail(data) {
//   return get(`/api/services/app/Ota/GetOtaDetail?otaId=${data.otaId}&language=${data.language}`)
// }

export function getOtaDevices(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
  return post('/api/services/app/Ota/GetOtaDevices', data)
}
export function getOtaUpgradeDetail(data) {
  return post(`/api/services/app/Ota/GetOtaUpgradeDetail`, data)
}
//Brand
export function getBrandInfos() {
  return get(`/api/services/app/Brand/GetBrandInfos`)
}
export function getBrandInfosNoAcess() {
  return get(`/api/services/app/Brand/GetBrandInfosNoAcess`)
}
export function deleteBrand(data) {
  return axiosDelete(`/api/services/app/Brand/DeleteBrand?code=${data}`)
}
export function creatBrand(data) {
  return post(`/api/services/app/Brand/CreatBrand`, data)
}
export function updateBrand(data) {
  return put(`/api/services/app/Brand/UpdateBrand`, data)
}
//DataAuth
export function getDataAuthByRole(roleId) {
  return get(`/api/services/app/DataAuth/GetDataAuthByRole?roleId=${roleId}`)
}
export function updateDataAuth(data) {
  return put(`/api/services/app/DataAuth/UpdateDataAuth`, data)
}
export function getInsightStatList() {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/InsightService/GetInsightStatList?BrandCode=${brandCode}`)
}
//UploadService
export function listBucketObject(data) {
  return get(`/api/services/app/UploadService/ListBucketObject`, data)
}
export function downLoadRunTImeFileFromS3(data) {
  return get(`/api/services/app/UploadService/DownLoadRunTImeFileFromS3?keyName=${data}`)
}
export function downLoadGsnFileFromS3(data) {
  return get(`/api/services/app/UploadService/DownLoadGsnFileFromS3?keyName=${data}`)
}

export function downLoadFoldFileFromS3(data) {
  return get(`/api/services/app/UploadService/DownLoadFoldFileFromS3?keyName=${data}`)
}
export function downLoadInsightFileFromS3(data) {
  return get(`/api/services/app/UploadService/DownLoadInsightFileFromS3?keyName=${data}`)
}
export function getCsvContent(data) {
  return get(`/api/services/app/UploadService/GetCsvContent?keyName=${data}`)
}


//unbound
export function getUnbindStatList(data) {
  data.BrandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return post(`/api/services/app/UnbindStatService/GetUnbindStatList`, data)
}
export function getUnbindStatDetailList(data) {
  return get(`/api/services/app/UnbindStatService/GetUnbindStatDetailList?mid=${data}`)
}
//联通
export function getUnicomSummaryData() {
  return get(`/api/services/app/UnicomService/GetUnicomSummaryData`)
}
export function getUnicomSixMonthBill() {
  return get(`/api/services/app/UnicomService/GetUnicomSixMonthBill`)
}
export function getUnicomSixMonthTraffic() {
  return get(`/api/services/app/UnicomService/GetUnicomSixMonthTraffic`)
}
export function getUnicomSevenDayTraffic() {
  return get(`/api/services/app/UnicomService/GetUnicomSevenDayTraffic`)
}
export function getUnicomDetail(data) {
  return post('/api/services/app/UnicomService/PostUnicomDetail', data)
}
//大屏接口
export function getShipmentStat() {
  return get('/api/services/app/StatService/GetShipmentStat')
}
export function getRegistrationStat() {
  return get('/api/services/app/StatService/GetRegistrationStat')
}
export function getOnlineStat() {
  return get('/api/services/app/StatService/GetOnlineStat')
}
export function getOfflineStat() {
  return get('/api/services/app/StatService/GetOfflineStat')
}
export function getBaseStat() {
  return get('/api/services/app/StatService/GetBaseStat')
}
export function getWarnStat() {
  return get('/api/services/app/StatService/GetWarnStat')
}
export function getTripStat() {
  return get('/api/services/app/StatService/GetTripStat')
}
export function getUtilizationStat() {
  return get('/api/services/app/StatService/GetUtilizationStat')
}
export function getMapStat() {
  return get('/api/services/app/StatService/GetMapStat')
}
export function getInsightStat() {
  return get('/api/services/app/StatService/GetInsightStat')
}
export function getScreenDataStat() {
  return get('/api/services/app/StatService/GetScreenDataStat')
}
export function getScreenDevice() {
  return get('/api/services/app/StatService/GetScreenDevice')
}
export function GetLifecycleCoreData(dsn, gsn, type, cycle) {
  return get(`/api/services/app/HealthReportService/GetLifecycleCoreData?dsn=${dsn}&gsn=${gsn}&type=${type}&cycle=${cycle}`)
}

export function GetPreviousLifecycleCoreData(dsn, gsn, type) {
  return get(`/api/services/app/HealthReportService/GetPreviousLifecycleCoreData?dsn=${dsn}&gsn=${gsn}&type=${type}`)
}
export function GetDeviceBasicInfo(dsn, gsn, type, cycle) {
  return get(`/api/services/app/HealthReportService/GetDeviceBasicInfo?dsn=${dsn}&gsn=${gsn}&type=${type}&cycle=${cycle}`)
}

export function GetContractList(dsns) {
  return post(`/api/services/app/HealthReportService/GetContractList`, dsns);
}
export function SaveNotes(id, notes) {
  return post(`/api/services/app/HealthReportService/SaveNotes?id=${id}&notes=${notes}`)
}

export function GetSfaInfoList(dsn) {
    return get(`/api/services/app/HealthReportService/GetSfaInfoList?dsn=${dsn}`)
}

export function GetNotes(id) {
  return get(`/api/services/app/HealthReportService/GetNotes?id=${id}`)
}
export function GetCycleCoreData(dsn, gsn, type, cycle) {
  return get(`/api/services/app/HealthReportService/GetCycleCoreData?dsn=${dsn}&gsn=${gsn}&type=${type}&cycle=${cycle}`)
}

export function GetPreviousCycleCoreData(dsn, gsn, type) {
  return get(`/api/services/app/HealthReportService/GetPreviousCycleCoreData?dsn=${dsn}&gsn=${gsn}&type=${type}`)
}
export function GetDeviceRateList(dsn, gsn, type, cycleType, cycle) {
  return get(`/api/services/app/HealthReportService/GetDeviceRateList?dsn=${dsn}&gsn=${gsn}&type=${type}&cycleType=${cycleType}&cycle=${cycle}`)
}

export function GetDeviceRunTimeRateList(dsn, gsn, type, cycleType, cycle) {
  return get(`/api/services/app/HealthReportService/GetDeviceRunTimeRateList?dsn=${dsn}&gsn=${gsn}&type=${type}&cycleType=${cycleType}&cycle=${cycle}`)
}
export function GetDeviceMetricsWeeklyList(dsn, gather, cycle) {
  return get(`/api/services/app/HealthReportService/GetDeviceMetricsWeeklyList?dsn=${dsn}&gather=${gather}&cycle=${cycle}`)
}
export function GetDeviceMetricsMonthlyList(dsn, gather, cycle) {
  return get(`/api/services/app/HealthReportService/GetDeviceMetricsMonthlyList?dsn=${dsn}&gather=${gather}&cycle=${cycle}`)
}
//站房监控大盘
export function getStationProjectList() {
  return get(`/api/services/app/StationMonitorServicecs/GetStationProjectList`)
}
export function getMonitorItemList() {
  return get(`/api/services/app/StationMonitorServicecs/GetMonitorItemList`)
}
export function getAvgPressureRangeData() {
  return get(`/api/services/app/StationMonitorServicecs/GetAvgPressureRangeData`)
}
export function getAvgFlowRangeData() {
  return get(`/api/services/app/StationMonitorServicecs/GetAvgFlowRangeData`)
}
export function getSumFlowByDay() {
  return get(`/api/services/app/StationMonitorServicecs/GetSumFlowByDay`)
}
export function getSumPowerByDay() {
  return get(`/api/services/app/StationMonitorServicecs/GetSumPowerByDay`)
}
export function getElectricitySaving() {
  return get(`/api/services/app/StationMonitorServicecs/GetElectricitySaving`)
}
export function getProjectMapData() {
  return get(`/api/services/app/StationMonitorServicecs/GetProjectMapData`)
}
// 单个空压站视角
export function getStationinfo(id) {
  return get(`/api/services/app/StationService/GetStationinfo?Id=${id}`)
}
export function getProjectMonitorData(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetProjectMonitorData?projectId=${id}`)
}
export function getFlowTrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetFlowThrendByProject?projectId=${id}`)
}
export function getPressureTrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetPressureThrendByProject?projectId=${id}`)
}
export function getPowerTrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetPowerThrendByProject?projectId=${id}`)
}
export function getDewPointTrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetDewPointThrendByProject?projectId=${id}`)
}
export function getSumFlowByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetSumFlowByProject?projectId=${id}`)
}
export function getSumPowerByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetSumPowerByProject?projectId=${id}`)
}
export function getSumBatteryByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetSumBatteryByProject?projectId=${id}`)
}
export function getAvgPressureByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetAvgPressureByProject?projectId=${id}`)
}
export function getAvgDewPointByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetAvgDewPointByProject?projectId=${id}`)
}
// 比功率
export function getSpecificPowerTrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetSpecificPowerThrendByProject?projectId=${id}`)
}
export function getAvgSpecificPowerRatioByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetSumSpecificPowerRatioByProject?projectId=${id}`)
}
// 单耗
export function getFlowPowerRatioTrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetFlowPowerRatioThrendByProject?projectId=${id}`)
}
export function getSumFlowPowerRatioByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetSumFlowPowerRatioByProject?projectId=${id}`)
}
// 总流量统计
export function getFlowStatisticsThrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetFlowStatisticsThrendByProject?projectId=${id}`)
}
// 总电量统计
export function getPowerStatisticsThrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetPowerStatisticsThrendByProject?projectId=${id}`)
}
// 单耗（按日为单位）
export function getUnitConsumptionStatisticsThrendByProject(id) {
  return get(`/api/services/app/StationMonitorServicecs/GetUnitConsumptionStatisticsThrendByProject?projectId=${id}`)
}

//common
export function sendEmail(data) {
  var brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR";
  return get(`/api/services/app/CommonService/SendEmail?userEmail=${data.userEmail}&psw=${data.psw}&type=${data.type}&brandCode=${brandCode}`)
}

export function validDevice(dsn) {
  return get(`/api/services/app/DeviceService/ValidDevice?dsn=${dsn}&url=${Globals.SYDeviceValidUrl}`)
}

//获取EMC潜在客户列表
export function getPotentialCustomerList(data) {
  return post(`/api/services/app/PotentialCustomerService/GetPotentialCustomerList`,data)
}

export function authOperationCheck(curPage) {
  var authOperation = [];
  var authOperationData = getItemFormLocalstorage("authOperations");
  //var authOperationData = this.$store.state.authOperationState;
  var authOper = storeIndex.state.authOperationState;
  if (authOperationData != null && authOperationData.length > 0) {
    authOperationData.forEach((o) => {
      if (o.split('_')[0] === curPage) {
        authOperation.push(o);
      }
    })
  }
  var resOperationAuth = {
    hasCreateAuth: false,
    hasUpdateAuth: false,
    hasDeleteAuth: false,
    hasRegisterAuth: false,
    hasUnBindAuth: false,
    hasQRCodeAuth: false,
    hasRePushGatherAuth: false,
    hasPushGatherAuth: false,
    hasMonitorAuth: false,
    hasResetPasswordAuth: false,
    hasPermissionSetAuth: false,
    hasImportAuth: false,
    hasExportAuth: false,
    hasUserActive: false,
    hasMaintainPush: false,
    hasMaintainConfirm: false,
    hasDeviceUpgrade: false,
    hasGatewayLocation: false,
    hasAlarmExport: false,
    hasDataAuth: false,
    hasDownLoadAuth: false,
    hasCcnDetailAuth: false,
    hasMonitorDetailAuth: false,
    hasDeviceInsightAuth: false,
    hasExportHistory: false,
    hasViewAuth: false,
    hasSyncSfaAuth: false,
    hasDeviceLocation: false,
    hasMondayIndexDownloadAuth: false
  }
  authOperation.forEach((o) => {
    if (o.indexOf("Create") >= 0) resOperationAuth.hasCreateAuth = true;
    if (o.indexOf("Update") >= 0) resOperationAuth.hasUpdateAuth = true;
    if (o.indexOf("Delete") >= 0) resOperationAuth.hasDeleteAuth = true;
    if (o.indexOf("Register") >= 0) resOperationAuth.hasRegisterAuth = true;
    if (o.indexOf("UnBind") >= 0) resOperationAuth.hasUnBindAuth = true;
    if (o.indexOf("QRCode") >= 0) resOperationAuth.hasQRCodeAuth = true;
    if (o.indexOf("RePushGather") >= 0) resOperationAuth.hasRePushGatherAuth = true;
    if (o.indexOf("PushGather") >= 0) resOperationAuth.hasPushGatherAuth = true;
    if (o.indexOf("ResetPassword") >= 0) resOperationAuth.hasResetPasswordAuth = true;
    if (o.indexOf("ResetPwd") >= 0) resOperationAuth.hasResetPasswordAuth = true;
    if (o.indexOf("RelieveLock") >= 0) resOperationAuth.hasRelieveLockAuth = true;
    if (o.indexOf("PermissionSet") >= 0) resOperationAuth.hasPermissionSetAuth = true;
    if (o.indexOf("Import") >= 0) resOperationAuth.hasImportAuth = true;
    if (o.indexOf("ExportHistory") >= 0) resOperationAuth.hasExportHistory = true;
    else if (o.indexOf("Export") >= 0) resOperationAuth.hasExportAuth = true;

    if (o.indexOf("MonitorPopup") >= 0) resOperationAuth.hasMonitorAuth = true;
    if (o.indexOf("Active") >= 0) resOperationAuth.hasUserActive = true;
    if (o.indexOf("Push") >= 0) resOperationAuth.hasMaintainPush = true;
    if (o.indexOf("Confirm") >= 0) resOperationAuth.hasMaintainConfirm = true;
    if (o.indexOf("Device_Upgrade") >= 0) resOperationAuth.hasDeviceUpgrade = true;
    if (o.indexOf("Gateway_Location") >= 0) resOperationAuth.hasGatewayLocation = true;
    if (o.indexOf("Alarm_Export") >= 0) resOperationAuth.hasAlarmExport = true;
    if (o.indexOf("DataAuth") >= 0) resOperationAuth.hasDataAuth = true;
    if (o.indexOf("DownLoad") >= 0) resOperationAuth.hasDownLoadAuth = true;
    if (o.indexOf("Ota_Upgrade") >= 0) resOperationAuth.hasOtaUpgradeAuth = true;
    if (o.indexOf("CcnDetail") >= 0) resOperationAuth.hasCcnDetailAuth = true;
    if (o.indexOf("MonitorDetail") >= 0) resOperationAuth.hasMonitorDetailAuth = true;
    if (o.indexOf("Insight") >= 0) resOperationAuth.hasDeviceInsightAuth = true;
    if (o.indexOf("View") >= 0) resOperationAuth.hasViewAuth = true;
    if (o.indexOf("SyncSfaAuth") >= 0) resOperationAuth.hasSyncSfaAuth = true;
    if (o.indexOf("Device_Location") >= 0) resOperationAuth.hasDeviceLocation = true;
    if (o.indexOf("MondayIndexDownload") >= 0) resOperationAuth.hasMondayIndexDownloadAuth = true;
  })

  refreshUserToken().then((res) => {
    console.log("refreshtoken");
    console.log(res);
    if (res.success === true) {
      setItemToLocalstorage("auth", res.result.accessToken);
      if (
        res.result.verifyId != undefined &&
        res.result.verifyId != null &&
        res.result.verifyId != ""
      ) {
        setCookie("vid", res.result.verifyId, 1);
      }
    }
  });

  return resOperationAuth;
}

export function dateFormat(date, format, hours) {
  if (hours == null || hours == "" || hours == undefined)
    hours = 0;
  date = new Date(date);
  var o = {
    'M+': date.getMonth() + 1, //month
    'd+': date.getDate(), //day
    'H+': date.getHours() + hours, //hour+8小时
    'm+': date.getMinutes(), //minute
    's+': date.getSeconds(), //second
    'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
    'S': date.getMilliseconds() //millisecond
  };
  if (/(y+)/.test(format))
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));

  for (var k in o)
    if (new RegExp('(' + k + ')').test(format))
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));

  return format;
}

export function exportExcel(headers, data, fileName) {
  const _headers = headers
    .map((item, i) => Object.assign({}, { key: item.key, title: item.title, position: String.fromCharCode(65 + i) + 1 }))
    .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { key: next.key, v: next.title } }), {});

  const _data = data
    .map((item, i) => headers.map((key, j) => Object.assign({}, { content: item[key.key], position: String.fromCharCode(65 + j) + (i + 2) })))
    // 对刚才的结果进行降维处理（二维数组变成一维数组）
    .reduce((prev, next) => prev.concat(next))
    // 转换成 worksheet 需要的结构
    .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { v: next.content } }), {});

  // 合并 headers 和 data
  const output = Object.assign({}, _headers, _data);
  // 获取所有单元格的位置
  const outputPos = Object.keys(output);
  // 计算出范围 ,["A1",..., "H2"]
  const ref = `${outputPos[0]}:${outputPos[outputPos.length - 1]}`;

  // 构建 workbook 对象
  const wb = {
    SheetNames: ['Sheet1'],
    Sheets: {
      Sheet1: Object.assign(
        {},
        output,
        {
          '!ref': ref,
          // eslint-disable-next-line
          '!cols': headers.map(item => ({ wpx: 100 }))
        }
      )
    }
  };

  // 导出 Excel
  XLSX.writeFile(wb, fileName);
}
export function exportExcelNew(excelData, fileName, csvContent) {
  if (csvContent && fileName.indexOf(".csv") > 0) {
    CsvExportor.downloadCsv(csvContent, excelData, fileName);
  } else {
    let ws = XLSX.utils.aoa_to_sheet(excelData)
    let wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    XLSX.writeFile(wb, fileName);
  }

}

export function exportExcelWithStyle(thData, trData, fileName) {

  let mergeArr = new Array();
  let colArr = new Object();
  let thDataArr = new Array();

  for (let index = 0; index < thData.length; index++) {
    const element = thData[index];
    let curthData = thMerge(element, index);
    mergeArr.push(...curthData.mergeArr);
    colArr = { ...colArr, ...curthData.colArr };
    thDataArr.push(curthData.thData);
  }
  let excelData = [...thDataArr, ...trData]
  // let excelData = aoa_to_sheet_fn(th, data)
  let ws = XLSX.utils.aoa_to_sheet(excelData);

  //合并单元格
  ws['!merges'] = mergeArr;
  //style
  for (let color in colArr) {
    ws[color].s = colArr[color];
  }

  console.log(ws);
  let wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

  let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
  let wbout = XLSXStyle.write(wb, wopts);
  function s2ab(s) {
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }
  // 导出表格
  FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "" }), fileName)

}

function thMerge(data, rowi) {
  let result = new Object();
  let mergeArr = new Array();
  let thData = new Array();
  let colArr = new Object();
  let letter = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];


  let cellCOunt = 0;
  for (let [name, val] of Object.entries(data)) {
    //取当前标题在excel中的坐标
    let curCellName = "";
    let count = rowi + 1;
    if (parseInt(cellCOunt / 26) == 0) {
      curCellName = letter[cellCOunt] + count
    } else {
      curCellName = letter[parseInt(cellCOunt / 26) - 1] + letter[parseInt(cellCOunt % 26)] + count
    }
    //添加的style 居中
    colArr[curCellName] = {
      font: {
        sz: 11,
      },
      alignment: {
        horizontal: "center",
        vertical: "center"
      },
    }
    //如果设置了fgColor添加背景色
    if (val.fgColor) {
      colArr[curCellName].fill = {
        fgColor: {
          rgb: val.fgColor
        }
      }
    }

    let length = data[name]?.length ?? 1;
    let curTh = (name == "empty" ? "" : name);

    let firstBorder = {
      border: {
        bottom: {
          style: 'thin',
          color: 'FF000000'
        },
        top: {
          style: 'thin',
          color: 'FF000000'
        },
        left: {
          style: 'thin',
          color: 'FF000000'
        }
      }

    };
    let midBorder = {
      border: {
        bottom: {
          style: 'thin',
          color: 'FF000000'
        },
        top: {
          style: 'thin',
          color: 'FF000000'
        }
      }
    }
    let lastBorser = {
      border: {
        bottom: {
          style: 'thin',
          color: 'FF000000'
        },
        top: {
          style: 'thin',
          color: 'FF000000'
        },
        right: {
          style: 'thin',
          color: 'FF000000'
        }
      }
    }
    let allBorser = {
      border: {
        bottom: {
          style: 'thin',
          color: 'FF000000'
        },
        top: {
          style: 'thin',
          color: 'FF000000'
        },
        right: {
          style: 'thin',
          color: 'FF000000'
        },
        left: {
          style: 'thin',
          color: 'FF000000'
        }
      }
    }
    for (let index = 0; index < length; index++) {
      thData.push(curTh.split('$$')[0]);
      //标题的每个单元格都要添加border边框第一个是上左下 中间是上下 最后一个是 上右下 只有一个是上下左右
      if (name != "empty") {
        if (parseInt((cellCOunt + index) / 26) == 0) {
          curCellName = letter[cellCOunt + index] + count
        } else {
          curCellName = letter[parseInt((cellCOunt + index) / 26) - 1] + letter[parseInt((cellCOunt + index) % 26)] + count
        }
        if (length == 1) {
          if (colArr[curCellName]) {
            colArr[curCellName].border = allBorser.border;
          } else {
            colArr[curCellName] = allBorser;
          }
        } else {
          if (index == 0) {
            if (colArr[curCellName]) {
              colArr[curCellName].border = firstBorder.border;
            } else {
              colArr[curCellName] = firstBorder;
            }
          } else if (index == length - 1) {
            if (colArr[curCellName]) {
              colArr[curCellName].border = midBorder.border;
            } else {
              colArr[curCellName] = midBorder;
            }
          } else {
            if (colArr[curCellName]) {
              colArr[curCellName].border = lastBorser.border;
            } else {
              colArr[curCellName] = lastBorser;
            }
          }
        }
      }

    }
    let merge = { s: { r: rowi, c: cellCOunt }, e: { r: rowi, c: cellCOunt - 1 + length } };
    mergeArr.push(merge);
    cellCOunt = cellCOunt + length;
  }
  result = {
    colArr: colArr,
    mergeArr: mergeArr,
    thData: thData
  }
  return result;
}

export function exportExcelCcn(headers, data, headers2, data2, fileName) {
  const _headers = headers
    .map((item, i) => Object.assign({}, { key: item.key, title: item.title, position: String.fromCharCode(65 + i) + 1 }))
    .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { key: next.key, v: next.title } }), {});

  const _data = data
    .map((item, i) => headers.map((key, j) => Object.assign({}, { content: item[key.key], position: String.fromCharCode(65 + j) + (i + 2) })))
    // 对刚才的结果进行降维处理（二维数组变成一维数组）
    .reduce((prev, next) => prev.concat(next))
    // 转换成 worksheet 需要的结构
    .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { v: next.content } }), {});

  // 合并 headers 和 data
  const output = Object.assign({}, _headers, _data);
  // 获取所有单元格的位置
  const outputPos = Object.keys(output);
  // 计算出范围 ,["A1",..., "H2"]
  const ref = `${outputPos[0]}:${outputPos[outputPos.length - 1]}`;

  // 构建 workbook 对象
  const wb = {
    SheetNames: ['点表', '错误信息'],
    Sheets: {
      点表: Object.assign(
        {},
        output,
        {
          '!ref': ref,
          // eslint-disable-next-line
          '!cols': headers.map(item => ({ wpx: 100 }))
        }
      ),

      // 错误信息: Object.assign(
      //   {},
      //   output2,
      //   {
      //     '!ref': ref2,
      //     // eslint-disable-next-line
      //     '!cols': headers2.map(item => ({ wpx: 100 }))
      //   }
      // )
    }
  };

  ////////////////第二个sheet begin////////////////////
  if (data2 != null && data2 != undefined && data2.length > 0) {
    const _headers2 = headers2
      .map((item, i) => Object.assign({}, { key: item.key, title: item.title, position: String.fromCharCode(65 + i) + 1 }))
      .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { key: next.key, v: next.title } }), {});
    const _data2 = data2
      .map((item, i) => headers2.map((key, j) => Object.assign({}, { content: item[key.key], position: String.fromCharCode(65 + j) + (i + 2) })))
      .reduce((prev, next) => prev.concat(next))
      .reduce((prev, next) => Object.assign({}, prev, { [next.position]: { v: next.content } }), {});

    const output2 = Object.assign({}, _headers2, _data2);
    const outputPos2 = Object.keys(output2);
    const ref2 = `${outputPos2[0]}:${outputPos2[outputPos2.length - 1]}`;
    wb.Sheets.错误信息 = Object.assign(
      {},
      output2,
      {
        '!ref': ref2,
        // eslint-disable-next-line
        '!cols': headers2.map(item => ({ wpx: 100 }))
      }
    );
  }
  ////////////////第二个sheet end////////////////////////

  // 导出 Excel
  XLSX.writeFile(wb, fileName);
}

export function exportExcelCcnList(excelData1, excelData2, fileName) {
  let ws = XLSX.utils.aoa_to_sheet(excelData1)
  let ws1 = XLSX.utils.aoa_to_sheet(excelData2)
  let wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, '点表')
  XLSX.utils.book_append_sheet(wb, ws1, '错误信息')
  XLSX.writeFile(wb, fileName);
}
export function downFile(url) {
  return get(url)
  // return request({  // request为封装的请求
  //   url,
  //   data: qs.stringify(parameter),
  //   method: 'get',
  //   responseType: 'blob'

  // })
}
export function menuActive(r) {

}